export default __webpack_public_path__ + "static/media/771366_facebook_logo_media_network_social_icon.d6562be8.png";